let message_no_new = null;
let message_loading = null;
let $dismiss_all_button = null;
let $announcements_message = null;
let $announcement_list = null;
let $announcements_container = null;

// VISIBILITY 
const VISIBILITY_CHECK_INTERVAL = 10 * 60 * 1000; // 10min interval
const MAX_VISIBILITY_CHECKS = 2; // Maximum number of checks after initial
const VISIBILITY_STORAGE_KEY = 'announcement_visibility_state';

am.$(function () {
	$dismiss_all_button = am.$('.am-announcements-dismiss-all');
	$announcement_list = am.$('.am-announcement-list');
	$announcements_container = am.$('.am-announcements-container');
	$announcements_message = am.$('.am-announcements-message');
	message_no_new = $announcement_list.parent().data('msg-no-new');
	message_loading = $announcement_list.parent().data('msg-loading');

	const {id, is_logged} = get_user_info();
	if (!is_logged) return;
	
	initializeVisibilityCheck(id);
});
	
function initializeVisibilityCheck(userId) {
    try {
        // Get stored state or create new one
        const storedState = localStorage.getItem(VISIBILITY_STORAGE_KEY);
        let visibilityState = storedState ? JSON.parse(storedState) : null;
        const now = Date.now();

        // Reset if:
        // 1. No stored state exists, OR
        // 2. We've reached max checks, OR
        // 3. Last check was more than 10min ago
        if (!visibilityState || 
            visibilityState.checkCount >= MAX_VISIBILITY_CHECKS || 
            (now - visibilityState.lastCheck > VISIBILITY_CHECK_INTERVAL)) {
            visibilityState = {
                checkCount: 0,
                lastCheck: now
            };
            // Perform initial check
            get_visible_count(userId);
            setupNextChecks(userId);
        } else {
            // If we haven't reached max checks, continue from where we left off
            if (visibilityState.checkCount < MAX_VISIBILITY_CHECKS) {
                const timeSinceLastCheck = now - visibilityState.lastCheck;
                if (timeSinceLastCheck >= VISIBILITY_CHECK_INTERVAL) {
                    // If enough time has passed, do a check now
                    get_visible_count(userId);
                    visibilityState.checkCount++;
                    visibilityState.lastCheck = now;
                    
                    if (visibilityState.checkCount < MAX_VISIBILITY_CHECKS) {
                        setupNextChecks(userId);
                    }
                } else {
                    // If not enough time has passed, schedule remaining checks
                    setupNextChecks(userId);
                }
            }
            // If we've reached max checks, do nothing until page refresh
        }

        localStorage.setItem(VISIBILITY_STORAGE_KEY, JSON.stringify(visibilityState));
    } catch (err) {
        console.error('Error in initializeVisibilityCheck:', err);
    }
}

function setupNextChecks(userId) {
    let storedState = JSON.parse(localStorage.getItem(VISIBILITY_STORAGE_KEY));
    
    if (!storedState || storedState.checkCount >= MAX_VISIBILITY_CHECKS) {
        if (storedState && storedState.checkCount >= MAX_VISIBILITY_CHECKS) {
            const timeUntilReset = VISIBILITY_CHECK_INTERVAL - (Date.now() - storedState.lastCheck);
            debugLog(`Announcements: Max checks reached. Can reset in ${(timeUntilReset/1000/60).toFixed(1)} minutes`);
        }
        return; // Don't set up more checks if we've reached the maximum
    }

    // Calculate next check time based on last check
    const now = Date.now();
    const nextCheckDelay = Math.max(0, VISIBILITY_CHECK_INTERVAL - (now - storedState.lastCheck));

    debugLog(`Announcements: Next check in ${(nextCheckDelay/1000/60).toFixed(1)} minutes`);

    const timeoutId = setTimeout(() => {
        storedState = JSON.parse(localStorage.getItem(VISIBILITY_STORAGE_KEY));
        
        if (storedState.checkCount >= MAX_VISIBILITY_CHECKS) {
            return;
        }

        get_visible_count(userId);
        storedState.checkCount++;
        storedState.lastCheck = Date.now();
        localStorage.setItem(VISIBILITY_STORAGE_KEY, JSON.stringify(storedState));

        // Schedule next check if needed
        if (storedState.checkCount < MAX_VISIBILITY_CHECKS) {
            setupNextChecks(userId);
        } else {
            const timeUntilReset = VISIBILITY_CHECK_INTERVAL - (Date.now() - storedState.lastCheck);
            debugLog(`Announcements: Max checks reached. Can reset in ${(timeUntilReset/1000/60).toFixed(1)} minutes`);
        }
    }, nextCheckDelay);
}

function show_retreving_annimation(type){
	// DEV-12312: content-shaped loading state (canon skeleton, m3/_skeleton.scss) —
	// card-shaped placeholders in the list instead of the global spinner, so the
	// panel shows the announcements' shape while they load. update_announcement_list
	// rewrites the list on success; the explicit removal below covers empty results.
	const list = document.querySelector('.am-announcement-list');
	if (type) {
		if (!list) return;
		const card =
			'<div class="am-skeleton-row am-skeleton-announcement">' +
				'<div class="am-skeleton am-skeleton--circle"></div>' +
				'<div class="am-skeleton-stack am-skeleton-row__lines">' +
					'<div class="am-skeleton am-skeleton--line am-skeleton--w-60"></div>' +
					'<div class="am-skeleton am-skeleton--line am-skeleton--w-40"></div>' +
				'</div>' +
			'</div>';
		list.insertAdjacentHTML('afterbegin', card + card + card);
		am.$(list).show();
		if (typeof am_skeleton_takeover === 'function') am_skeleton_takeover();
	} else if (list) {
		list.querySelectorAll('.am-skeleton-announcement').forEach(function (el) { el.remove(); });
	}
}

function get_visible_count(id){
	am.$.get('/ajax/get_visible_announcements/', {contact_id: id, count_only: true}, function (data) {
		update_announcement_count(data);
	});
}

function toggleText(event) {
    event.stopPropagation();
    const element = event.target;
    const id = element.closest('.am-announcement').dataset.id;
    const textTag = element.closest('.am-announcement-text');
    const fullText = window.announcements_texts[id];
    const isOpen = textTag.getAttribute('data-open') === 'true';
    let content = get_trimmed_text(fullText);

    if (isOpen) {
        //closing
		var seeMoreText = get_language_translation('LANG_SEE_MORE');
        textTag.innerHTML = content + `...&nbsp;<span class="am-announcement-text-toggle" onclick="toggleText(event)">` + seeMoreText + `</span>`;
    } else {
        //opening
		var seeLessText = get_language_translation('LANG_SEE_LESS');
        textTag.innerHTML = fullText + `&nbsp;<span class="am-announcement-text-toggle" onclick="toggleText(event)">` + seeLessText + `</span>`;
    }
    textTag.setAttribute('data-open', !isOpen);
}

function undo_dismiss_announcement(announcement_id) {
	var $ann_msg = am.$('.am-announcements-message');
	if($ann_msg.show())
		$ann_msg.hide()

	am.$.post('/announcements/undo_dismiss/' + announcement_id + '/', () => {})
	.then(() => {
		const $announcement = am.$('#announcement_' + announcement_id);
		$announcement.slideDown('slow', () => {
			if (is_mobile_or_tablet()){
				const mobileCont = document.querySelector('#announcement_' + announcement_id + '> .am-announcement-container');
				toggle_dismiss(mobileCont, false);
			}
			$announcement.show()
			.removeClass('am-announcement-dismissed')
		});

		if($announcement.hasClass('am-announcement-unread')){
			var new_count = (get_announcement_count() == 0) ? 1 : get_announcement_count() + 1;
			update_announcement_count(new_count);
		}

		show_snackbar({
			message: get_language_translation('LANG_UNDO_COMPLETE'),
			type: 'success',
			timer: 750,
			show_close: false,
			from_undo: true
		});
	})
	.fail(() => {
		show_snackbar({
			message: get_language_translation('LANG_SOMETHING_WENT_WRONG_PLZ_TRY_AGAIN'),
			type: 'danger',
			timer: 3000,
			show_close: false
		});
	})

}

function toggle_bs_dropdown_auto_close(toggle){
	var dropdownAnchors = am.$('.dropdown-announcements-nav-link');
	var dropdowns = document.querySelectorAll('.dropdown-announcements .nav-link');

	dropdownAnchors.each(() => {
		am.$(this).attr('data-bs-auto-close', toggle);
	})
	dropdowns.forEach((dropdown) => {
		bootstrap.Dropdown.getOrCreateInstance(dropdown).dispose();
	})
}

function show_announcement_annimation(kill=false){
    var $ann_list = am.$('.am-announcement-list');
    var $display_ann = $ann_list.children(':first')
    var $shake_container = $display_ann.children('.am-announcement-container')

    ensureGSAP().then(function(){
        const timeline = gsap.timeline({ defaults: {duration: .5}, onComplete: function(){
            $shake_container.removeClass('open')
        }})
        if($ann_list.attr('data-slide-shown') || kill)
            timeline.kill();
        else{
            timeline
                .to($shake_container, {left: '0px'}, 'start')
                .to($shake_container, {left: '-100px'})
                .to({}, .5, {}) // Required for simulated .5s pause between slide left - right
                .to($shake_container, {left: '0px'})
                .set($shake_container, {clearProps: 'all'});

                $ann_list.attr('data-slide-shown', true)
        }
    });
}

function close_snackbar(t){
	am.$(t).parent().closest('.toast').remove();
}

function dismiss_announcement(t, announcement_id) {
	var $this = am.$(t);
	$this.css({pointerEvents: "none"});
	const $announcement = am.$('#announcement_' + announcement_id);
	am.$.get('/announcements/dismiss/' + announcement_id + '/', (data) => {
		$announcement.slideUp('fast', () => {
			$announcement.hide()
			.addClass('am-announcement-dismissed')

			const announcement_count = am.$('.am-announcement-list').children('div:not(.am-announcement-dismissed)').length;

			if (announcement_count  === 0) {
				$announcements_message.text(message_no_new).fadeIn();
				$dismiss_all_button.fadeOut();
			}
		});

		if($announcement.hasClass('am-announcement-unread')){
			var count = get_announcement_count();
			const new_count = (count == 1) ? 0 : count - 1;
			update_announcement_count(new_count);
		}
	})
	.then((data) => {
		show_snackbar({
			// Trusted, locally-built markup with required inline handlers (data is the
			// numeric announcement id from the dismiss endpoint); render as-is, no sanitize.
			message: get_language_translation('LANG_ANNOUNCEMENT_DISMISSED') + '. ' + `<a class="btn-undo" onmouseover="toggle_bs_dropdown_auto_close('false')" onmouseout="toggle_bs_dropdown_auto_close('outside')" onclick="close_snackbar(this); undo_dismiss_announcement(${data})"><strong> ${get_language_translation('LANG_LABEL_UNDO').capitalize()} </strong></a>`,
			html: true,
			type: 'success',
			show_close: false,
			aux_class: 'ann-dismissed'
		});
		setTimeout(function() {
			$this.css({pointerEvents: "auto"});
		}, 2500);
	})
	.fail(() => {
		show_snackbar({
			message: get_language_translation('LANG_SOMETHING_WENT_WRONG_PLZ_TRY_AGAIN'),
			type: 'danger',
			timer: 3000,
			show_close: false
		});
		setTimeout(function() {
			$this.css({pointerEvents: "auto"});
		}, 2500);
	})

	return false;
}

function mark_announcement(t, announcement_id) {
	var status = am.$(t).data('read_status');
	var $announcement = am.$('#announcement_' + announcement_id);
	const $icon = $announcement.children('.am-announcement-container').children('.am-announcement-icon');
	$announcement.toggleClass('am-announcement-read', 'am-announcement-unread')
	
	if(status == 'read'){
		$announcement.addClass('am-announcement-read').removeClass('am-announcement-unread')
		$icon.addClass('am-announcement-icon--read').removeClass('am-announcement-icon--unread');
		var msg = get_language_translation('LANG_MARK_AS_UNREAD');
	}
	else if(status == 'unread'){
		$announcement.addClass('am-announcement-unread').removeClass('am-announcement-read')
		$icon.addClass('am-announcement-icon--unread').removeClass('am-announcement-icon--read');
		var msg = get_language_translation('LANG_MARK_AS_READ');
	}
	
	const $body = am.$('body');
	if($body.hasClass('am-breakpoint-large') || $body.hasClass('am-breakpoint-xlarge') || $body.hasClass('am-breakpoint-xxlarge')){
		toggle_tooltip({
			target: '#announcement_marked_'+announcement_id, 
			msg: msg, 
			timer: 3000
		});
	}

	
	am.$.post('/announcements/marked/',{ann_id: announcement_id, read: status})
	.done(() => {
		if(status == 'read'){
			var new_count = ((get_announcement_count() - 1) <= 0) ? 0 : (get_announcement_count() - 1 );
		}
		else if(status == 'unread'){
			var new_count = (get_announcement_count() >= 0) ? get_announcement_count() + 1 : 0;
		}
		am.$(t).data('read_status', (status == 'read') ? 'unread' : 'read');

		update_announcement_count(new_count);
	}).fail(() => {
		show_snackbar({
			message: get_language_translation('LANG_SOMETHING_WENT_WRONG_PLZ_TRY_AGAIN'),
			type: 'danger'
		});
	});
}

function dismiss_all_announcements() {
	const url = 'announcements/dismiss_all/';
	new Ajax.Request(url, {
		onSuccess: function() {
			$announcements_message.text(message_no_new).fadeIn();
			$announcement_list.fadeOut('fast', () => {
				$announcement_list.empty();
			});
			update_announcement_count(0);
			$dismiss_all_button.fadeOut();
			am.$('#js-load-more-announcements').addClass('am-load-more-announcements--hide').removeClass('am-load-more-announcements--show');
		}
	});
	return false;
}

function get_announcement_count() {
	return parseInt(am.$(".am-announcement-count").attr('ann_count'));
}

function update_announcement_count(cnt) {
	const $announcements_badge = am.$('.am-announcement-count');
	const newCount = parseInt(cnt);

	if (newCount > 0) {
		$announcements_badge.text(newCount > 9 ? '9+' : newCount).fadeIn({opacity: 1})
			.attr('title', newCount + ' announcement(s)')
			.attr('ann_count', newCount);
		am.$('.js-announcementIcon').addClass('has-announcement');
	} else {
		$announcements_badge.fadeOut().attr('title', '')
		.attr('ann_count', newCount);
		am.$('.js-announcementIcon').removeClass('has-announcement');
	}
}

function extract_p_content(text){
	var replaceHtmlSpaces = text.replace(/&nbsp;/g, ' ')
	var replacedBr = replaceHtmlSpaces.replace(/<br\s*\/?>/g, '');
	var newLines = replacedBr.replace(/<p>/g, '').replace(/<\/p>/g, '. ');
	var replaced = newLines.replace(/\n/g, '');

	return replaced;
}

function get_trimmed_text(fullText) {
	try{
		if(fullText.includes('\n'))
			var replaced = extract_p_content(fullText);
	}catch(e){
		console.log(e)
	}

    let htmlText = am.$('<div></div>').html(replaced ? replaced : fullText );
	let char_count = 0;
    let result = '';
    const nodes = htmlText.get(0).childNodes;
    const charLimit = 85;

    for (let i = 0; i < nodes.length; i++) {
        const e = nodes[i];
        char_count += e.textContent.length;

        if (char_count >= charLimit) {
            e.textContent = e.textContent.substring(0, charLimit);
            result += e.nodeName === '#text' ? e.textContent : e.outerHTML;
            break;
        }

        result += e.nodeName === '#text' ? e.textContent : e.outerHTML;
    }

    return result;
}

function toggle_dismiss(el, open = null) {
	if (!is_mobile_or_tablet()) {
		return;
	}

	let isOpen = el.dataset.open === 'true';

	if (open != null) {
		isOpen = !open;
	}

	el.classList.toggle('open', !isOpen);
	el.dataset.open = !isOpen;
}

function build_announcement_ui(announcement) {
	let text = announcement.body;
	/*
	* we get the length of the html code and add it to the actual text, so we don't crop it incorrectly
	* full content:
	* <a href="catalog/resell/local_catalog/supply/edit/11/">B2B Supply #11</a>
	*
	* content without text
	* <a href="catalog/resell/local_catalog/supply/edit/11/"></a>
	*
	* text
	* B2B Supply #11
	*/
	let htmlText = am.$('<div></div>').html(announcement.body);
    let content = get_trimmed_text(announcement.body);
	if (htmlText.text().length > 150 || htmlText.text().includes('\n')) {
		var seeMoreText = get_language_translation('LANG_SEE_MORE');
		text = content + `...&nbsp;<span class="am-announcement-text-toggle" onclick="toggleText(event)">` + seeMoreText + `</span>`;
	}
	var announcementByText = get_language_translation('LANG_SYSTEM_ANNOUNCMENT_BY');
	var postedByText = get_language_translation('LANG_LABEL_POSTED_BY');
	var dismissText = get_language_translation('LANG_LABEL_DISMISS');

	if(announcement.disable_dismiss){
		var onclick_event = '';
		var tt_title = announcement.disabled_msg;
		var dismiss_btn_class = "am-announcement-dismiss--disabled"
	}else{
		var onclick_event = `dismiss_announcement(this, ${announcement.id})`;
		var tt_title = dismissText;
		var dismiss_btn_class = '';
	}
	
	if(announcement.is_system && !announcement.is_b2b){
		var icon = "fa-info-circle";
	}
	else if(announcement.is_b2b){
			var icon = "fa-briefcase";
	}else{
		var icon = "fa-megaphone";
	}

	const $body = am.$('body');
	if($body.hasClass('am-breakpoint-large') || $body.hasClass('am-breakpoint-xlarge') || $body.hasClass('am-breakpoint-xxlarge')){
		var tt_attrs = `
			data-bs-toggle="tooltip"
			data-bs-placement="right"
			data-bs-container="body"
		` 
	}else{
		var tt_attrs = ``;
	}

	onclick="dismiss_announcement(this, ${announcement.id})" 
	const $element = am.$(`<div class="am-announcement ${announcement.read ? 'am-announcement-read':'am-announcement-unread'}" id="announcement_${announcement.id}" data-id="${announcement.id}" data-announcement-id="${announcement.announcement_id}">
				<div class="am-announcement-container">
					<div class="am-announcement-icon">
						<i id="announcement_marked_${announcement.id}" class="fa fa-fw ${icon}" 
						${announcement.read ? 
							`onclick="mark_announcement(this, ${announcement.id})" 
							${tt_attrs}
							data-read_status="unread"
							data-bs-title="${get_language_translation('LANG_MARK_AS_UNREAD')}"` 
							:
							`onclick="mark_announcement(this, ${announcement.id})" 
							${tt_attrs}
							data-read_status="read"
							data-bs-title="${get_language_translation('LANG_MARK_AS_READ')}"`}
						></i>
					</div>
					
					<div class="am-announcement-content">
						<div class="am-announcement-header">
							<span><strong>${announcement.is_system ? announcementByText : postedByText}:</strong>&nbsp;${announcement.submitter}&nbsp;${announcement.is_edited ? "(edited)" : ""}</span>
							<span data-bs-toggle="tooltip" title="${is_dev_mode() && announcement.expired_date ? (get_language_translation('LANG_LABEL_EXPIRES_AFTER')+ ': ' + announcement.expired_date) : ''}">${announcement.formatted_date}</span>
						</div>
						<div class="am-announcement-body">
							<div class="am-announcement-text" data-open="false">${text}</div>
							<div class="am-announcement-dismiss-container">
								<button class="am-announcement-dismiss ${dismiss_btn_class}"
										onclick="${onclick_event}"
										data-bs-toggle="tooltip"
										data-bs-placement="left"
										data-bs-container="body"
										data-bs-title="${tt_title}">
									<i class="fa fa-minus-circle"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
				
				<div class="am-announcement-dismiss-container" onclick="dismiss_announcement(this, ${announcement.id})">
					<button class="am-announcement-dismiss">
						<i class="fa fa-minus-circle"></i>
					</button>
				</div>
			</div>`);

    if (!window.announcements_texts) {
        window.announcements_texts = [];
    }
    window.announcements_texts[announcement.id] = announcement.body;

	const $container = $element.find('.am-announcement-container').get(0);

	GUI.swipeDetect($container, (swipedir) => {
		if (swipedir === 'left' || swipedir === 'right') {
			toggle_dismiss($container, swipedir === 'left');
		}
	});

	return $element;
}

function update_announcement_list(data, more) {
	if(Array.isArray(data)){
		const newMsgCount = data.filter(a => !a.read).length;

		if (data.length > 1) {
			$dismiss_all_button.fadeIn();
		} else {
			$dismiss_all_button.fadeOut();
		}

		update_announcement_count(newMsgCount);

		if (data.length > 0) {
			$announcements_message.slideUp({queue: false}).fadeOut({queue: false});
			var announcements = data.map(a => build_announcement_ui(a));
			$announcement_list.html(announcements).fadeIn();
			initializeTooltips();
		} else {
			$announcements_message.text(message_no_new).fadeIn();
		}
	}
}

function get_msg_count(){
	// Sets load more amount after 50 announcements are reached
	const $announcement_count_ele = am.$("#js-load-more-announcements");
	var prevCount = parseInt($announcement_count_ele.attr('loadcount'));
	// we can turn this + val into a var as a user creature feature setting in the future. ex(10,15,25,50,etc) - M.Yandow 4/17/23
	var newCount = prevCount + 50;
	return newCount;
}

function load_announcements(more=false, silent=false) {
	if(!silent || more)
		show_retreving_annimation(true);

	$lmb = am.$("#js-load-more-announcements");
	if(!more)
		$lmb.addClass('am-load-more-announcements--hide').removeClass('am-load-more-announcements--show');

	return new Promise((resolve, reject) => {
        const {id, is_logged} = get_user_info();

        if (!is_logged) {
            resolve();
            return;
        }

		if ($announcements_container.data('loading') === true) {
			return;
		}

		if (!silent) {
			$dismiss_all_button.hide();
			$announcements_container.data('loading', true);
			if(!more){
				$announcement_list.empty();
				show_retreving_annimation(true);
			}
		}
		var count = !more ? 50 : get_msg_count();

		am.$.get('/ajax/get_visible_announcements/', { contact_id: id, cur_count: count}, function (data) {
			if(data.length != 0){
				$lmb.attr('loadcount', (silent ? ((data.length >= 50) ? 50 : data.length) : count));
				if(more && (count >= 50)){
					if(data.length <= 49)
						$lmb.addClass('am-load-more-announcements--hide').removeClass('am-load-more-announcements--show');
					else if(data.length < count)
						$lmb.addClass('am-load-more-announcements--hide').removeClass('am-load-more-announcements--show');
					else
						$lmb.addClass('am-load-more-announcements--show').removeClass('am-load-more-announcements--hide');
				}
				else if(!more && $lmb.hasClass('am-load-more-announcements--hide') && (data.length >= 50)){
					$lmb.addClass('am-load-more-announcements--show').removeClass('am-load-more-announcements--hide');
				}
				else if(count <= 49){
					$lmb.addClass('am-load-more-announcements--hide').removeClass('am-load-more-announcements--show');
				}
			}

			update_announcement_list(data, more);
			$announcements_container.data('loading', false);
			show_retreving_annimation(false);
			resolve();
		});
	})
}

function initTree(el) {
	el = $(el);
	var i,j;
	var spanA, spanB, spanC;
	var startingPoint, stoppingPoint, childUL;

	// Find all LIs to process
	for(i=0;i<el.childElements().length;i++) {
		if(el.childElements()[i].tagName && el.childElements()[i].tagName.toLowerCase() == 'li') {
			var li = el.childElements()[i];
			if(!$('static_announcement_tree'))
				Event.observe(li.down('span.check'),'click',function(ev) {checkUncheck(ev.element())});
			spanA = document.createElement('span');
			spanA = $(spanA);
			spanB = document.createElement('span');
			spanC = document.createElement('span');
			spanA.appendChild(spanB);
			spanB.appendChild(spanC);
			spanA.className = 'a ' + li.className.replace('closed','spanClosed');
			spanA.onMouseOver = function() {}
			spanB.className = 'b';
			spanB.onclick = treeToggle;
			spanC.className = 'c';


			// Find the UL within the LI, if it exists
			stoppingPoint = li.childNodes.length;
			startingPoint = 0;
			childUL = null;
			for(j=0;j<li.childNodes.length;j++) {
				if(li.childNodes[j].tagName && li.childNodes[j].tagName.toLowerCase() == 'div') {
					startingPoint = j + 1;
					continue;
				}

				if(li.childNodes[j].tagName && li.childNodes[j].tagName.toLowerCase() == 'ul') {
					childUL = li.childNodes[j];
					stoppingPoint = j;
					break;
				}
			}

			// Move all the nodes up until that point into spanC
			for(j=startingPoint;j<stoppingPoint;j++) {
				spanC.appendChild(li.childNodes[startingPoint]);
			}

			// Insert the outermost extra span into the tree
			if(li.childNodes.length > startingPoint)
				li.insertBefore(spanA, li.childNodes[startingPoint]);
			else li.appendChild(spanA);

			// Process the children
			if(childUL != null) {
				if(initTree(childUL)) {
					li.addClassName('children');
					spanA.addClassName('children');
				}
			}
			li.select('.tocheck').each(function(el) { checkUncheck(el); el.removeClassName('tocheck');});
		}
	}
	if (li) {
		li.addClassName('last');
		spanA.addClassName('last');
		return true;
	}
	else
		return false;
}

/*
used from:
http://doc.silverstripe.com/doku.php?id=tree-control&amp;s=tree%20control
*/

function initTree(el) {
	el = $(el);
	var i,j;
	var spanA, spanB, spanC;
	var startingPoint, stoppingPoint, childUL;

	// Find all LIs to process
	for(i=0;i<el.childElements().length;i++) {
		if(el.childElements()[i].tagName && el.childElements()[i].tagName.toLowerCase() == 'li') {
			var li = el.childElements()[i];
			if(!$('static_announcement_tree'))
				Event.observe(li.down('span.check'),'click',function(ev) {checkUncheck(ev.element())});
			spanA = document.createElement('span');
			spanA = $(spanA);
			spanB = document.createElement('span');
			spanC = document.createElement('span');
			spanA.appendChild(spanB);
			spanB.appendChild(spanC);
			spanA.className = 'a ' + li.className.replace('closed','spanClosed');
			spanA.onMouseOver = function() {}
			spanB.className = 'b';
			spanB.onclick = treeToggle;
			spanC.className = 'c';


			// Find the UL within the LI, if it exists
			stoppingPoint = li.childNodes.length;
			startingPoint = 0;
			childUL = null;
			for(j=0;j<li.childNodes.length;j++) {
				if(li.childNodes[j].tagName && li.childNodes[j].tagName.toLowerCase() == 'div') {
					startingPoint = j + 1;
					continue;
				}

				if(li.childNodes[j].tagName && li.childNodes[j].tagName.toLowerCase() == 'ul') {
					childUL = li.childNodes[j];
					stoppingPoint = j;
					break;
				}
			}

			// Move all the nodes up until that point into spanC
			for(j=startingPoint;j<stoppingPoint;j++) {
				spanC.appendChild(li.childNodes[startingPoint]);
			}

			// Insert the outermost extra span into the tree
			if(li.childNodes.length > startingPoint)
				li.insertBefore(spanA, li.childNodes[startingPoint]);
			else li.appendChild(spanA);

			// Process the children
			if(childUL != null) {
				if(initTree(childUL)) {
					li.addClassName('children');
					spanA.addClassName('children');
				}
			}
			li.select('.tocheck').each(function(el) { checkUncheck(el); el.removeClassName('tocheck');});
		}
	}
	if (li) {
		li.addClassName('last');
		spanA.addClassName('last');
		return true;
	}
	else
		return false;
}

/*
 * +/- toggle the tree, where el is the <span class="b"> node
 * force, will force it to "open" or "close"
 */
function treeToggle(el, force) {
	if (el===undefined || (!force && el.element() != this))
		return;
	el = this;

	while(el != null && (!el.tagName || el.tagName.toLowerCase() != "li")) el = el.parentNode;

	// Get UL within the LI
	var childSet = el.down('ul');
	var topSpan = el.down('span');

	if( force != null ){
		if( force == "open"){
			treeOpen( topSpan, el )
		}
		else if( force == "close" ){
			treeClose( topSpan, el )
		}
	}
	else if( childSet != null) {
		// Is open, close it
		if(!el.className.match(/(^| )closed($| )/)) {
			treeClose( topSpan, el )
		// Is closed, open it
		} else {
			treeOpen( topSpan, el )
		}
	}
}
function openAll(container){
	$(container).select('span.b').each(function(n) {
		treeOpen(n, n.up('li'));
	});
	return false;
}
function closeAll(container) {
	$(container).select('span.b').each(function(n) {
		treeClose(n, n.up('li'));
	});
	return false;
}
function treeOpen( a, b ){
	a.removeClassName('spanClosed');
	b.removeClassName('closed');
}
function treeClose( a, b ){
	a.addClassName('spanClosed');
	b.addClassName('closed');
}
/* Only used by settings/edit_trigger_new.tpl
function checkGroup(check, container) {
	container = $(container);
	(check.hasClassName('checked') ? check.removeClassName('checked') : check.addClassName('checked'));
	if (check.getAttribute('rel') == '') {
		var list
		$$('span.company_check').each(function(n) {checkUncheck(n,(check.hasClassName('checked') ? 'checked' : 'unchecked'))});
	}
	else {
		$$('span.'+check.getAttribute('rel')).each(function(n) {checkUncheck(n,(check.hasClassName('checked') ? 'checked' : 'unchecked'))});
	}
	checkRoots();
}
*/
function checkUncheck(el, force) {
	if (force == undefined)
		(el.hasClassName('checked') ? el.removeClassName('checked') : el.addClassName('checked'));
	else {
		if (force == 'checked')
			el.addClassName('checked');
		else
			el.removeClassName('checked');
	}
	var inp = el.next('input');
	if (inp)
		inp.name = (el.hasClassName('checked') ? inp.name.replace('n_contacts','contacts') : inp.name.replace('contacts','n_contacts'));
	if (el.hasClassName('partialcheck')) {
		el.removeClassName('partialcheck');
		el.addClassName('checked');
		treeOpen(el.up(), el.up('li'));
	}
	else if (el.hasClassName('checked'))
		treeOpen(el.up(), el.up('li'));
	else
		treeClose(el.up(), el.up('li'));
	if (el.up('li').select('ul input'))
		el.up('li').select('ul .check').each(function(n) {
			(el.hasClassName('checked') ? n.addClassName('checked') : n.removeClassName('checked'));
			var inp = n.next('input');
			if (inp)
				inp.name = (el.hasClassName('checked') ? inp.name.replace('n_contacts','contacts') : inp.name.replace('contacts','n_contacts'));
		});
	var parent = el.up('li').up('li');
	if (parent)
		checkIfAllChecked(parent.down('span.check'));
	else if (!force)
		checkRoots();
}
function checkIfAllChecked(el) {
	if (!el)
		return;
	if (!el.up('li').select('ul .check').any(function(n) { return n.hasClassName('checked')})) {
		el.removeClassName('partialcheck');
	}
	else if (!el.up('li').select('ul .check').any(function(n) { return !n.hasClassName('checked')})) {
		el.addClassName('checked');
		el.removeClassName('partialcheck');
	}
	else {
		el.removeClassName('checked');
		el.addClassName('partialcheck');
	}
	var parent = el.up('li').up('li');
	if (parent)
		checkIfAllChecked(parent.down('span.check'));
	else
		checkRoots();
}
function checkState(n) {
	if (n.hasClassName('checked'))
		return 2;
	else if (n.hasClassName('partialcheck'))
		return 1;
	return 0;
}
function checkRoots(level) {
	return false;
	/* Only used by settings/edit_trigger_new.tpl
	if(!$('allCheck'))
	{
		console.log('Unnecessary call to checkRoots()');
		return;
	}
	else
		console.log('Necessary call to checkRoots()');
	if (level == undefined) {
		['customer','employer','vendor'].each(function(n) {checkRoots(n)});
		var list = $$('span.company_check');
		var count = list.inject(0, function(acc,n) {return acc + checkState(n)});
		if (count == 0) {
			var el = $('allCheck');
			el.removeClassName('partialcheck');
		}
		else if (count == (list.length * 2)) {
			var el = $('allCheck');
			el.addClassName('checked');
			el.removeClassName('partialcheck');
		}
		else {
			var el = $('allCheck');
			el.removeClassName('checked');
			el.addClassName('partialcheck');
		}
	}
	else {
		var list = $$('span.'+level);
		var count = list.inject(0, function(acc,n) {return acc + checkState(n)});
		if (count == 0) {
			var el = $(level+'Check');
			el.removeClassName('partialcheck');
			el.removeClassName('checked');
		}
		else if (count == (list.length * 2)) {
			var el = $(level+'Check');
			el.addClassName('checked');
			el.removeClassName('partialcheck');
		}
		else {
			var el = $(level+'Check');
			el.removeClassName('checked');
			el.addClassName('partialcheck');
		}
	}
	*/
}

// define special conditions upon which validation fails below
function announcement_validation(mox){
	var SelRecipiantText = get_language_translation('LANG_PLEASE_SEL_AT_LEAST_ONE_RECIPIENT') + ".";
	mox.validate(mox.form.select('input[name="contacts[]"]').length, 'contact_list_legend', SelRecipiantText);
	mox.date('expiration_date', MoxForm.now);
};

function delete_announcement(log, ajaxy) {
	var tr = $(log).up('tr');
	var announcement_id = tr.id.match(/\d+$/).pop();  console.log(announcement_id);
	if(confirm(get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ANNOUNCEMENT'))){
		var url = 'announcements/delete/'+announcement_id+'/';
		if(ajaxy){
			new Ajax.Request(url, {
				parameters : { 'log' : announcement_id, 'ajax' : 1 },
				onSuccess : function(ret){
					tr.remove();
					add_notification(get_language_translation('LANG_ANNOUNCEMENT_DELETED_SUCCESSFULLY'), 'success');
				}
			});
		}
	}
	return false;
}